module.exports = __webpack_public_path__ + "static/img/11.39dba79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/11.png
// module id = QL3a
// module chunks = 0